import i18n from '@/i18n'

// https://www.iana.org/domains/root/db
const firstTLDs = 'ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|be|bf|bg|bh|bi|bj|bm|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|cl|cm|cn|co|cr|cu|cv|cw|cx|cz|de|dj|dk|dm|do|dz|ec|ee|eg|es|et|eu|fi|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|im|in|io|iq|ir|is|it|je|jo|jp|kg|ki|km|kn|kp|kr|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|na|nc|ne|nf|ng|nl|no|nr|nu|nz|om|pa|pe|pf|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|yt'.split(
  '|'
)
const secondTLDs = 'com|edu|gov|net|mil|org|nom|sch|caa|res|off|gob|int|tur|ip6|uri|urn|asn|act|nsw|qld|tas|vic|pro|biz|adm|adv|agr|arq|art|ato|bio|bmd|cim|cng|cnt|ecn|eco|emp|eng|esp|etc|eti|far|fnd|fot|fst|g12|ggf|imb|ind|inf|jor|jus|leg|lel|mat|med|mus|not|ntr|odo|ppg|psc|psi|qsl|rec|slg|srv|teo|tmp|trd|vet|zlg|web|ltd|sld|pol|fin|k12|lib|pri|aip|fie|eun|sci|prd|cci|pvt|mod|idv|rel|sex|gen|nic|abr|bas|cal|cam|emr|fvg|laz|lig|lom|mar|mol|pmn|pug|sar|sic|taa|tos|umb|vao|vda|ven|mie|北海道|和歌山|神奈川|鹿児島|ass|rep|tra|per|ngo|soc|grp|plc|its|air|and|bus|can|ddr|jfk|mad|nrw|nyc|ski|spy|tcm|ulm|usa|war|fhs|vgs|dep|eid|fet|fla|flå|gol|hof|hol|sel|vik|cri|iwi|ing|abo|fam|gok|gon|gop|gos|aid|atm|gsm|sos|elk|waw|est|aca|bar|cpa|jur|law|sec|plo|www|bir|cbg|jar|khv|msk|nov|nsk|ptz|rnd|spb|stv|tom|tsk|udm|vrn|cmw|kms|nkz|snz|pub|fhv|red|ens|nat|rns|rnu|bbs|tel|bel|kep|nhs|dni|fed|isa|nsn|gub|e12|tec|орг|обр|упр|alt|nis|jpn|mex|ath|iki|nid|gda|inc'.split(
  '|'
)

// 與後端約定可用的通訊協議與子域名，有新需求可自行添加
const protocolList = 'http|https|wss|mqtt'.split('|')
const subdomainList = 'api|api-op|wss|mqtt|ad-api|www'.split('|')

// const domainList = {
//   apk: '/otp/Authenticator.5.00.apk',
//   addTimestamp(url, name) {
//     const timestamp = Date.now()
//     return (url += `${this.name}?t=${timestamp}`)
//   }
// }

/**
 *
 * @method convertBaseUrlFromEnv
 * @param {String} envVariable 傳入設置在 webpack 環境變數的 API baseUrl
 * @param {String} expected 可選: 預期的網址轉換結果
 * # envVariable 參數規則
 *   1. 不含 ^_^ 字符: 將值原封不動回傳
 *   2. 含 ^_^ 字符，執行流程:
 *     - 假設傳入環境變數: VUE_APP_BASE_URL = api^_^https
 *     - 拆解成 ['api', 'https']
 *     - 將參數傳入 convertBaseUrl 函式，進行網址替換後回傳
 */
export const convertBaseUrlFromEnv = (envVariable, expected = null) => {
  if (/\^_\^/g.test(envVariable)) {
    const [subdomain, protocol] = envVariable.split('^_^')
    const domainAfterConvert = convertBaseUrl(subdomain, protocol)
    expected !== null && testUrl(domainAfterConvert, expected)
    return domainAfterConvert
  } else {
    return envVariable
  }
}

export const convertSocketUrlFromEnv = envVariable => {
  if (/^{SOCKET}/g.test(envVariable)) {
    const prefix = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
    let host = window.location.host
    if (host.slice(0, 4) === 'www.') {
      host = 'wss.' + host.substring(4)
    }
    return `${prefix}${host}${envVariable.replace('{SOCKET}', '')}`
  } else {
    return envVariable
  }
}

/**
 *
 * @method convertBaseUrl
 * @param {String}  subdomain 子域名
 * @param {String}  protocol 通訊協議名
 * @param {String}  domainForTesting ＃hostname，測試用參數，勿傳。預設透過 location.hostname 抓取當前域名。
 * @return {String}  以傳入子域名與協議名替代 JS 抓取到的 hostname 之對應網址部位，並返回。
 *
 */
export const convertBaseUrl = (
  subdomain = 'api',
  protocol = 'https',
  domainForTesting
) => {
  if (!window.location.hostname)
    throw new Error(
      i18n.t('i18n_browser_not_support').concat(' location.hostname')
    )
  const validateProtocol =
    protocolList.some(i => protocol === i) || protocolList.includes(protocol)
  if (!validateProtocol)
    throw new Error(i18n.t('i18n_find_no_protocol', { protocol }))
  const validateSubdomain =
    subdomainList.some(i => subdomain === i) ||
    subdomainList.includes(subdomain)
  if (!validateSubdomain)
    throw new Error(i18n.t('i18n_find_no_subdomain', { subdomain }))

  const _domain = domainForTesting || location.hostname
  let [domain] = _domain.split('/')
  // let [domain, ...path] = _domain.split('/')
  // const other = `/${path.join('/')}` // path and query string...
  domain = domain.replace(/^www\./, '')
  const parts = domain.split('.')

  while (parts.length > 3) {
    parts.shift()
  }

  if (
    parts.length === 3 &&
    ((parts[1].length > 2 && parts[2].length > 2) ||
      (secondTLDs.indexOf(parts[1]) === -1 &&
        firstTLDs.indexOf(parts[2]) === -1))
  ) {
    parts.shift()
  }
  const resultUrl = `${protocol}://${subdomain}.${parts.join('.')}`
  return resultUrl
}

const testUrl = (domainAfterConvert, expected) => {
  if (expected === domainAfterConvert) {
    console.log(
      'OK： "' +
        location.hostname +
        '" should be "' +
        expected +
        '" ,and it is really "' +
        domainAfterConvert +
        '"'
    )
  } else {
    console.log(
      'Fail: "' +
        location.hostname +
        '" should be "' +
        expected +
        '" ,but it is NOT "' +
        domainAfterConvert +
        '"'
    )
  }
}

/**
 * 測試網址轉換後是否符合預期
 *
 * @method testBaseUrl
 * @param {Object} tests { 欲測試域名: 預期結果 }
 * @param {String}  subdomain 欲轉換的子域名
 * @param {String}  protocol 欲轉換的通訊協議名
 * @example
 *     testBaseUrl({
 *        'www.silkrode.com.tw': 'wss://wss.silkrode.com.tw'
 *     }, 'wss', 'wss');
 */
export const testBaseUrl = (tests, subdomain = 'api', protocol = 'https') => {
  tests = tests || {
    // 測試網域: 預期結果
    'example.com': 'https://api.example.com',
    'sub.example.com': 'https://api.example.com',
    'example.com.tw': 'https://api.example.com.tw',
    'sub.example.com.tw': 'https://api.example.com.tw'
  }
  if (Object.prototype.toString.call(tests) !== '[object Object]')
    throw new Error(`param "tests" should be Object.`)
  for (let test in tests) {
    if (Object.prototype.hasOwnProperty.call(tests, test)) {
      const original = test,
        expected = tests[test],
        result = convertBaseUrl(subdomain, protocol, original),
        isExpected = expected === result
      if (isExpected) {
        console.log(
          'OK： "' +
            original +
            '" should be "' +
            expected +
            '" ,and it is really "' +
            result +
            '"'
        )
      } else {
        console.log(
          'Fail: "' +
            original +
            '" should be "' +
            expected +
            '" ,but it is NOT "' +
            result +
            '"'
        )
      }
    }
  }
}
